var _rect, _circle, _path, _path2, _path3, _circle2, _circle3, _path4, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#d6a42c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#daae45",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#4f7a58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124L70 88C66 92 54 92 50 88Z",
    fill: "#f4eee0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88L60 124M70 88L60 124",
    stroke: "#3f6146",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 102,
    r: 1.5,
    fill: "#3f6146"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 112,
    r: 1.5,
    fill: "#3f6146"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d4b090"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f1c8a4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f1c8a4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bb9c7f",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48Q51 44 57 48",
    stroke: "#b8b8c0",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63 48Q69 44 75 48",
    stroke: "#b8b8c0",
    strokeWidth: 3.8000000000000003,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48C36 32 46 26 56 26L50 32C44 34 41 40 40 50ZM82 48C84 32 74 26 64 26L70 32C76 34 79 40 80 50Z",
    fill: "#e8e8ee"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26C56 24 64 24 68 26",
    stroke: "#e8e8ee",
    strokeWidth: 3,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait15);
export default __webpack_public_path__ + "static/media/player-portrait-15.fa5530babaeb315483df32c937c05ff7.svg";
export { ForwardRef as ReactComponent };